const reviewClasses = {
  container:
    'flex flex-col justify-between border rounded border-slate-700 p-8 gap-4 mb-4 w-full sm:w-3/4 md:w-3/4 mx-auto',
  edit: 'cursor-pointer bg-gray-800 hover:bg-gray-900 rounded-full px-4 p-1',
  delete: 'cursor-pointer bg-gray-800 hover:bg-gray-900 rounded-full px-2 p-1',
  form: 'flex flex-col mt-8 w-full',
  section: 'flex flex-col mb-4',
  label: 'font-semibold text-lg',
  input: 'border p-2 bg-slate-800 border-slate-700',
  button:
    'text-white font-semibold text-lg bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 rounded-lg px-5 py-2.5 mr-2 mb-2',
}

export default reviewClasses
